"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RocheSelectDropdown = void 0;

require("core-js/modules/es.string.small.js");

var _react = _interopRequireDefault(require("react"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _FilledInput = _interopRequireDefault(require("@material-ui/core/FilledInput"));

var _divider = require("../divider");

var _core = require("../core");

var _utils = require("../utils");

var _selectDropdown = require("./select-dropdown.styles");

var _clsx4 = _interopRequireDefault(require("clsx"));

var _excluded = ["classes", "variant", "size", "label", "required", "autoSelectWidth", "inputProps", "formControlProps"],
    _excluded2 = ["small", "noLabel", "divider"],
    _excluded3 = ["filledOutlined"],
    _excluded4 = ["filledOutlined"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RocheSelectDropdown = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _clsx2;

  var classes = _ref.classes,
      variant = _ref.variant,
      size = _ref.size,
      label = _ref.label,
      required = _ref.required,
      autoSelectWidth = _ref.autoSelectWidth,
      inputProps = _ref.inputProps,
      formControlProps = _ref.formControlProps,
      rest = _objectWithoutProperties(_ref, _excluded);

  // Select width auto adjust based on label width.
  var labelRef = _react["default"].useRef();

  var _React$useState = _react["default"].useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      labelWidth = _React$useState2[0],
      setLabelWidth = _React$useState2[1];

  _react["default"].useEffect(function () {
    var handleLabelResize = function handleLabelResize() {
      var _labelRef$current, _labelRef$current$get;

      setLabelWidth((_labelRef$current = labelRef.current) === null || _labelRef$current === void 0 ? void 0 : (_labelRef$current$get = _labelRef$current.getBoundingClientRect()) === null || _labelRef$current$get === void 0 ? void 0 : _labelRef$current$get.width);
    };

    if (autoSelectWidth) {
      var _labelRef$current2, _labelRef$current3;

      (_labelRef$current2 = labelRef.current) === null || _labelRef$current2 === void 0 ? void 0 : _labelRef$current2.addEventListener('resize', handleLabelResize);
      (_labelRef$current3 = labelRef.current) === null || _labelRef$current3 === void 0 ? void 0 : _labelRef$current3.addEventListener('transitionend', handleLabelResize);
      handleLabelResize();
    }

    return function () {
      if (autoSelectWidth) {
        var _labelRef$current4, _labelRef$current5;

        (_labelRef$current4 = labelRef.current) === null || _labelRef$current4 === void 0 ? void 0 : _labelRef$current4.removeEventListener('resize', handleLabelResize);
        (_labelRef$current5 = labelRef.current) === null || _labelRef$current5 === void 0 ? void 0 : _labelRef$current5.removeEventListener('transitionend', handleLabelResize);
      }
    };
  }, [labelRef.current, autoSelectWidth]); // Styles.


  var _mergeClasses = (0, _utils.mergeClasses)((0, _selectDropdown.useSelectStyles)({
    labelWidth: labelWidth
  }), classes),
      smallClass = _mergeClasses.small,
      noLabelClass = _mergeClasses.noLabel,
      dividerClass = _mergeClasses.divider,
      innerSelectClasses = _objectWithoutProperties(_mergeClasses, _excluded2);

  var _useLabelStyles = (0, _selectDropdown.useLabelStyles)(),
      filledOutlinedLabelClass = _useLabelStyles.filledOutlined,
      innerLabelClasses = _objectWithoutProperties(_useLabelStyles, _excluded3);

  var _useInputStyles = (0, _selectDropdown.useInputStyles)(),
      filledOutlinedInputClass = _useInputStyles.filledOutlined,
      innerInputClasses = _objectWithoutProperties(_useInputStyles, _excluded4); // Calculated flags.


  var hasLabel = label && size === 'medium';
  var shrinkedLabel = rest.displayEmpty || rest.value !== null && rest.value !== undefined && rest.value !== '';
  var isOutlined = variant === 'outlined';
  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], _extends({
    variant: "filled",
    error: rest.error
  }, formControlProps), hasLabel ? /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], {
    ref: labelRef,
    classes: _objectSpread(_objectSpread({}, innerLabelClasses), {}, {
      root: (0, _clsx4["default"])(innerLabelClasses.root, _defineProperty({}, filledOutlinedLabelClass, isOutlined))
    }),
    required: required,
    shrink: shrinkedLabel,
    disabled: rest.disabled
  }, label) : null, /*#__PURE__*/_react["default"].createElement(_Select["default"], _extends({
    classes: _objectSpread(_objectSpread({}, innerSelectClasses), {}, {
      root: (0, _clsx4["default"])(innerSelectClasses.root, (_clsx2 = {}, _defineProperty(_clsx2, smallClass, size === 'small'), _defineProperty(_clsx2, noLabelClass, !hasLabel), _clsx2))
    }),
    input: /*#__PURE__*/_react["default"].createElement(_FilledInput["default"], {
      classes: _objectSpread(_objectSpread({}, innerInputClasses), {}, {
        root: (0, _clsx4["default"])(innerInputClasses.root, _defineProperty({}, filledOutlinedInputClass, isOutlined))
      })
    }),
    endAdornment: isOutlined ? /*#__PURE__*/_react["default"].createElement(_divider.RocheDivider, {
      variant: "fullWidth",
      orientation: "vertical",
      className: dividerClass
    }) : null,
    variant: "filled",
    ref: ref
  }, rest)));
});

exports.RocheSelectDropdown = RocheSelectDropdown;
RocheSelectDropdown.displayName = (0, _core.rochePrefix)('SelectDropdown');
RocheSelectDropdown.defaultProps = {
  variant: 'filled',
  size: 'medium',
  required: false,
  autoSelectWidth: false,
  disableUnderline: true
};
var _default = RocheSelectDropdown;
exports["default"] = _default;